import createIcon from '../createIcon';

export const DesktopIcon = createIcon({
  path: (
    <path
      d="M40 36C42.2 36 43.98 34.2 43.98 32L44 12C44 9.8 42.2 8 40 8H8C5.8 8 4 9.8 4 12V32C4 34.2 5.8 36 8 36H0V40H48V36H40ZM8 12H40V32H8V12Z"
      fill="currentColor"
    />
  ),
});
